var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.258 1.302a1.82 1.82 0 0 0-2.586 0l-.21.21a1.85 1.85 0 0 0 0 2.603l8.742 8.8-8.911 8.97a1.85 1.85 0 0 0 0 2.603l.21.21a1.82 1.82 0 0 0 2.586 0L13 15.729l8.912 8.97a1.82 1.82 0 0 0 2.585 0l.21-.21a1.85 1.85 0 0 0 0-2.603l-8.911-8.97 8.742-8.8a1.85 1.85 0 0 0 0-2.602l-.21-.211a1.82 1.82 0 0 0-2.586 0L13 10.1 4.258 1.3z", fill: "#F1F1F1" })
  );
});